var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DatePicker',_vm._b({staticClass:"w-full",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'DatePicker',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }